import moment from 'moment'

const checkIndex = (arr, index) => {
  return typeof arr[index] !== 'undefined'
}

const findChildren = (orders, order, index) => {
  const sameItems = orders.filter(o =>
    parseInt(o.price) === parseInt(order.price));
  const numOfSame = sameItems?.length || 1

  return {
    childCount: numOfSame,
    splicedIndex: index + numOfSame,
    holder: {
      ...order,
      childCount: 0
    },
    size: sameItems.reduce((accumulator, object) => {
      return accumulator + object.size;
    }, 0)
  }
}

const arrangeOrders = (orders) => {
  const spliced = [];
  const arranged = orders
    .filter(o => !(o?.groupContainer || false))
    .map((order, index) => {

      let prevIndex = index - 1;
      let nextIndex = index + 1;

      const prevOrder = checkIndex(orders, prevIndex) ?
        orders[prevIndex] : null;
      const nextOrder = checkIndex(orders, nextIndex) ?
        orders[nextIndex] : null;

      // Хэрэв өмнөх элементийн үнэтэй адилхан байвал харуулахдаа групплэхийн тулд
      // childCount нь нь 0 гэсэн утгатай үүснэ.
      if (prevOrder && parseInt(prevOrder.price) === parseInt(order.price)) {
        return ({
          ...order,
          childCount: 0
        })
      }

      // Хэрэв өмнөх болон хойдохтойгоо үнийн хувьд ялгаатай байвал харуулна
      if (!(parseInt(prevOrder?.price || 0) !== parseInt(order.price)
        || parseInt(nextOrder?.price || 0) !== parseInt(order.price))
      ) {
        return ({
          ...order,
          childCount: 1
        })
      }

      const {
        size,
        childCount,
        splicedIndex,
        holder
      } = findChildren(orders, order, index)

      // Хэрэв групплэсэн тохиолдолд эхний элементийн мэдээллийг
      // засварлахаас өмнө шинэ элемент болгон оруулах
      if (childCount > 1) {
        spliced[splicedIndex] = holder
      }

      order.size = size;

      return ({
        ...order,
        groupContainer: childCount > 1,
        childCount
      })
    });

  for(const _index of Object.keys(spliced)) {
    arranged.splice(_index, 0, spliced[_index])
  }

  return arranged
}

/**
 * Зөвхөн дэд захиалгуудыг үлдээх
 * @param orders
 * @returns {*}
 */
const flattenOrders = (orders) => orders
  .filter(o => o.childCount <= 1)
  .map(o => ({
    ...o,
    childCount: 1
  }))

const sortOrders = (orders) => orders.sort((a, b) => b.price - a.price)
const sortOrdersAsc = (orders) => orders.sort((a, b) => a.price - b.price)

const isOffer = (order) => parseInt(order.type) === 1

/**
 * Хэрэв тухайн мэдээлэл захиалгын дэвтэрт байвал алгасах
 * @param orders
 * @param id
 */
const pushNotExist = (orders, order) => {
  if (orders.find(_order => _order.md_entry_id === order.md_entry_id))
    return 0;

  return orders.push(order)
}

/**
 * Centrifugo -оос ирсэн сокетийн мсжийг
 * өгөгдлийн сангийн форматтанд оруулах
 * price, size,
 * MDEntryID
 * MDEntryType
 * @param data
 */
const normalizeMsg = (msg) => {
  // Захиалгын өөрчлөлт байвал шинэчлэлийг нь ялгаж авах
  let payload = {};
  if (typeof msg.data === 'object' && msg.data !== null) {
    payload = msg.data
  } else if (Array.isArray(msg.data) && msg.data.length === 1) {
    payload = msg.data[0]
  } else {
    payload = msg.data
  }

  if (!Array.isArray(payload) && payload.MessageType.toUpperCase() === 'X') {
    const { SendingTime, NoMDEntries } = payload
    // MDEntryType == 2 байвал биелсэн арилжаа
    const trades = NoMDEntries
      .filter(entry => entry.MDEntryType === '2')
      .map(entry => ({
        date: moment(), // Одооны цагийг явуулахад асуудалгүй юм байна
        size: entry.MDEntrySize,
        price: entry.MDEntryPx,
      }))

    const deleted = []

    return {
      trades,
      deleted,
      orders: null
    }
  }

  console.debug(payload);

  const orders = payload.filter(p => typeof p.MDEntryType !== 'undefined' &&
    typeof p.MDEntryPx !== 'undefined' &&
    typeof p.MDEntryPositionNo !== 'undefined' &&
    typeof p.MDEntrySize !== 'undefined' &&
    typeof p.MDPriceLevel !== 'undefined')
    .map(item => ({
      size: item.MDEntrySize,
      type: item.MDEntryType,
      price: item.MDEntryPx,
      level: item.MDPriceLevel,
      md_entry_id: item.MDEntryID,
    }));

  // Snapshot төрлийн мсж байвал MAP хийгээд буцаах
  return {
    trades: [],
    deleted: [],
    orders
  }
}

export {
  isOffer,
  checkIndex,
  sortOrders,
  flattenOrders,
  findChildren,
  arrangeOrders,
  normalizeMsg,
  pushNotExist,
  sortOrdersAsc
}
